import Intervals from '../../../base/errors/airdome/Intervals';

const intervals: Intervals = {
  GeneralError: 'An error occurred while editing the air dome.'
};

export default intervals;
